import { Box, Flex } from '@chakra-ui/react';
import { LuArrowDownRight, LuArrowUpRight } from 'react-icons/lu';
import { TONE, toneOf } from './tones';

/**
 * A change, as Copilot draws it: a 22px pill on the tone's tint with an arrow
 * for the direction and the number in semibold.
 *
 * `good` picks the tone (true green, false red, null neutral) and `up` the
 * arrow; the two differ for debt, where a rise is bad news. A null `pct` (no
 * history to compare) draws a dash.
 */
export default function DeltaPill({ pct, good, up, suffix = '', ...rest }) {
  const neutral = pct == null || good == null;
  return (
    <Flex
      as="span"
      display="inline-flex"
      align="center"
      gap="4px"
      h="22px"
      px="8px"
      borderRadius="full"
      fontSize="13px"
      fontWeight={600}
      lineHeight={1}
      whiteSpace="nowrap"
      flexShrink={0}
      {...TONE[toneOf(neutral ? null : good)]}
      {...rest}
    >
      {pct == null ? '—' : (
        <>
          {!neutral && <Box as={up ? LuArrowUpRight : LuArrowDownRight} boxSize="13px" flexShrink={0} />}
          {/* The number and its "%" are one text: the pill's gap is for the arrow. */}
          <Box as="span">{`${Math.abs(pct).toFixed(2)}%${suffix}`}</Box>
        </>
      )}
    </Flex>
  );
}
